var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('drawer',[_c('h1',[_vm._v("\n\t\tЗаявки необходимо смотреть на вкладке \"Помощь программиста\"\n\t\t"),_c('a',{attrs:{"href":"switchTab"}},[_vm._v("Перейти")])])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62bc10ac","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./Components/supportNew/infoPage.vue
// module id = 463
// module chunks = 0